import React, { useEffect, useState } from "react";
import PageContent from "../components/PageContent";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { userActions } from "../store/index";
import jwt_decode from "jwt-decode";

const LoginAsPage = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [message, setMessage] = useState("Redirecting...");

  const { id, token } = params;

  const nest_url = process.env.REACT_APP_NEST_URL;
  const url = nest_url + "public/me/login_as";
  const secretCode = process.env.REACT_APP_SECRET_CODE;

  const headers = {
    secret: secretCode,
    "Content-Type": "application/json",
  };

  function fetchData() {
    fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify({ id: id, token: token }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (!data.success) {
          setMessage(data.message);
        } else {
          localStorage.setItem("auth_data", JSON.stringify(data.data));

          const decodedToken = jwt_decode(data.data.jwt);

          dispatch(
            userActions.login({
              empCode: decodedToken.empCode,
              empName: decodedToken.empName,
              empEmail: data.data.email,
            })
          );

          dispatch(
            userActions.updatePhoto({
              empPhoto: `${data.data.foto}?timestamp=${Date.now()}`,
            })
          );

          navigate("/");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <PageContent>
      <div className="error-page" style={{ backgroundColor: "white" }}>
        <img
          src="/img-1.png"
          className="top-left-image"
          alt="Top Left"
          style={{ backgroundColor: "transparent" }}
        />
        <div className="error-content p-3" style={{ backgroundColor: "white" }}>
          <h1 className="error-title" style={{ backgroundColor: "white" }}>
            {message}
          </h1>
        </div>
        <img
          src="/img-2.png"
          className="bottom-right-image"
          alt="Bottom Right"
          style={{ backgroundColor: "transparent" }}
        />
        <div className="muted-text" style={{ backgroundColor: "white" }}>
          © 2023 Colibri LMS. All rights reserved.
        </div>
      </div>
    </PageContent>
  );
};

export default LoginAsPage;
